import React from 'react'
import classNames from 'classnames'

import Tooltip from '../tmoUiHelpers/textHelpers/Tooltip'
import useWindowWidth from '../tmoHooks/useWindowWidth'
import { DIMENSIONS } from '../tmoUtilities/constants'

import style from './TmoButton.module.css'

const TmoButton = ({
  className,
  icon,
  children,
  disabled,
  selected,
  size = 'md',
  type = 'primary',
  buttonType = 'button',
  tooltip,
  position = 'bottom',
  textVisible,
  testId,
  ...rest
}) => {
  const window = useWindowWidth()

  const tooltipText = React.Children.toArray(children)
    .filter((child) => typeof child === 'string')
    .join(' ')

  const RenderButton = () => {
    return (
      <button
        className={classNames(
          type === 'magenta_primary' ||
            type === 'magenta_secondary' ||
            type === 'magenta_primary_icon' ||
            type === 'magenta_secondary_icon' ||
            type === 'magenta_link' ||
            type === 'magenta_icon_btn'
            ? style.btn
            : style.button,
          style[size],
          style[type],
          disabled && style.disabled,
          selected && style.selected,
          textVisible && style.is_mobile_visible,
          className
        )}
        disabled={disabled}
        selected={selected}
        role='button'
        type={buttonType}
        data-testid={testId}
        {...rest}
      >
        {icon && <span className={style.icon}>{icon}</span>}
        {icon && children ? (
          <div className={style.btn_text}> {children} </div>
        ) : (
          <React.Fragment> {children}</React.Fragment>
        )}
      </button>
    )
  }

  return (
    <React.Fragment>
      {tooltip ? (
        <Tooltip position={position} tooltip={tooltip} type='primary'>
          <RenderButton />
        </Tooltip>
      ) : (
        <React.Fragment>
          {(type === 'magenta_primary' || type === 'magenta_secondary') &&
          window <= DIMENSIONS.MOBILE_WIDTH &&
          !textVisible &&
          icon ? (
            <Tooltip tooltip={tooltipText} type='primary' position={position}>
              <RenderButton />
            </Tooltip>
          ) : (
            <RenderButton />
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  )
}

export default TmoButton
